import { Component } from '@angular/core';

@Component({
  templateUrl: 'main.component.html'
})
export class MainComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/components/main/main.component.ts